export default {
  toast_messages: {
    google_review_uploaded: 'Je review is succesvol geverifieerd. Je hebt {{points}} pts verdiend 😉',
  },
};
